/**
 * Created by mykurisu on 2017/6/8.
 */
import React, {Component} from 'react'
import {connect} from 'react-redux'

import '../../styles/lecture/LectureCellpro.css';


class LectureCellPro extends Component {

    static defaultProps = {
        cell: {
            title: '听课须知',
        }
    }

    constructor() {
        super()
        this.state = {
            contentShow: false
        }
    }

    handleCellContentShow() {
        this.setState({
            contentShow: !this.state.contentShow 
        })
    }

    render() {
        return (
            <div className="lecture-cellpro__container">
                <div className={"lecture-cellpro margin-top " + (!this.state.contentShow ? 'lecture-cellpro_bottomborder' : 'lecture-cellpro_bottomborder-zero')}>
                    <div className={"lecture-cellpro-title " + (this.state.contentShow && 'lecture-cellpro-title_active')} onClick={this.handleCellContentShow.bind(this)}>
                        <div className="lecture-cellpro-title_bd fontSetSizeTitle">
                            {this.props.cell.title}
                        </div>
                        <div className={"lecture-cellpro-title_angle " + (!this.state.contentShow ? 'lecture-cellpro-title_angle-normal' : 'lecture-cellpro-title_angle-active')}></div>
                    </div>
                    <div className={"lecture-cellpro-main " + (!this.state.contentShow ? 'lecture-cellpro-main-normal' : 'lecture-cellpro-main-active')}>
                        {this.props.children}
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(state => ({
    lectureType: state.lecture.lecture.lecture_type
}))(LectureCellPro)



// WEBPACK FOOTER //
// ./src/components/lecture/LectureCellPro.js